import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getUser, updateUser } from "../../api/auth.api";

export const useProfile = (mobno, options = {}) => {
  return useQuery({
    queryKey: ["userProfile", mobno],
    queryFn: () => getUser(mobno),
    enabled: !!mobno,
    ...options,
  });
};

export const useUpdateProfile = (options = {}) => {
  const queryClient = useQueryClient();
  const mobno = localStorage.getItem("loginname");

  return useMutation({
    mutationFn: (data) => updateUser(data),
    onSuccess: (data) => {
      // Invalidate the userProfile query to fetch the updated data
      queryClient.invalidateQueries(["userProfile", mobno]);
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      if (options.onError) {
        options.onError(error);
      }
    },
  });
};
